<template>
	<div class="nb-app">

		<NprogressContainer/>

		<router-view></router-view>
	</div>


</template>


<script>
	import NprogressContainer from 'vue-nprogress/src/NprogressContainer'

	import {MessageBox, Notification} from 'element-ui'
	import Pager from  "./common/model/base/Pager"
	import Topic from  "./common/model/topic/Topic"

	export default {
		data () {
			return {}
		},
		computed: {

			topicManager(){
				return this.$store.state.topicManager;
			}
		},
		components: {
			NprogressContainer
		},
		mounted(){


			let that = this;
			//在这里可以做很多初始工作，此时框架已经起来了,Vue实例也已经创建完毕.
			//加载系统中所有的topic.
			this.topicManager.httpInit();


		}
	}

</script>

<style lang="less" rel="stylesheet/less">

	@import "./common/assets/css/app.less";

	.nb-app {

		height: 100%;

		.nprogress-container {
			position: fixed !important;
			width: 100%;
			height: 150px;
			z-index: 2048;
			pointer-events: none;

			#nprogress {
				//@color: #48e79a;
				@color: #1ab394;

				.bar {
					background: @color;
				}
				.peg {
					box-shadow: 0 0 10px @color, 0 0 5px @color;
				}

				.spinner-icon {
					border-top-color: @color;
					border-left-color: @color;
				}
			}
		}

	}


</style>



// WEBPACK FOOTER //
// App.vue?b2ea2842